import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/i18n"; // initialize i18n before app renders
import { App } from "@/app/App";
import { initializeLoggerInBackground } from "@/services/logging/initializer";
import { initializeTrackerInBackground } from "@/services/tracking/initializer";

import "./main.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Initialize logger in the background without blocking app startup
import { log } from "@/services/logging/logger";
initializeLoggerInBackground().catch((error: Error) => {
  log("error", "main", "Failed to initialize logger", error);
});

// Initialize tracker in the background without blocking app startup
initializeTrackerInBackground().catch((error: Error) => {
  log("error", "main", "Failed to initialize tracker", error);
});
